// Muster „Scharf schalten" (docs/gestaltung.md): die zweite Geste einer
// folgenreichen Aktion als Symbol. Der erste Klick schaltet scharf -- das
// Symbol färbt sich an seinem Platz (SymbolKnopf `ton`), daneben steht ein
// ✕ zum Abbrechen --, der zweite Klick löst aus. Ein Doppelklick zählt
// nicht als zweiter Klick, und nach 5 s fällt es von selbst zurück.
// Tim 29.09.2026: „Das mit dem Button, der dann rot wird zur Bestätigung
// ist richtig gut. Lass uns das als Design-Pattern aufnehmen."
//
// Eine Instanz je Seite oder Komponente; der Schlüssel sagt, welche Aktion
// an welchem Eintrag scharf ist („neustart:forge", „verwerfen:<topic>"),
// sodass immer höchstens eine scharf ist.
//
//   const scharf = new Scharf();
//   <SymbolKnopf icon="power" ton={scharf.ist(k) ? "danger" : undefined}
//     label={scharf.ist(k) ? "Wirklich neu starten? Nochmal klicken" : "Neu starten"}
//     onclick={() => scharf.klick(k) && neustarten()} />
//   {#if scharf.ist(k)}<SymbolKnopf icon="x" label="Abbrechen" onclick={() => scharf.ab()} />{/if}

/** Wie lange ein scharf geschalteter Knopf wartet. */
export const SCHARF_MS = 5_000;
/** Kürzer als das gilt ein zweiter Klick als Doppelklick. */
export const DOPPELKLICK_MS = 500;

export class Scharf {
  /** Schlüssel der scharf geschalteten Aktion, sonst null. */
  key = $state<string | null>(null);
  #um = 0;
  #timer: ReturnType<typeof setTimeout> | undefined;

  ist(key: string): boolean {
    return this.key === key;
  }

  /** Ist irgendetwas scharf, dessen Schlüssel so beginnt? */
  istEins(prefix: string): boolean {
    return this.key != null && this.key.startsWith(prefix);
  }

  /** Klick auf den Knopf. true heißt: jetzt auslösen. */
  klick(key: string): boolean {
    if (this.key !== key) {
      this.#scharf(key);
      return false;
    }
    if (Date.now() - this.#um < DOPPELKLICK_MS) return false;
    this.ab();
    return true;
  }

  /** Zurückfallen, ohne auszulösen (✕, Escape, Zeile zu). */
  ab(): void {
    if (this.#timer) clearTimeout(this.#timer);
    this.#timer = undefined;
    this.key = null;
  }

  #scharf(key: string): void {
    if (this.#timer) clearTimeout(this.#timer);
    this.key = key;
    this.#um = Date.now();
    this.#timer = setTimeout(() => (this.key = null), SCHARF_MS);
  }
}
